import React, {useContext} from "react";
import {Box, Button} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import HeaderTop from "./headerTop";
import {MenuContext} from "../../contexts/menuContext";
import Invite from "../../components/invite";

import profileImg from "../../assets/images/profileImg.svg";
import menu from "../../assets/images/menu.svg";
import premium from "../../assets/images/premium.svg";
import invite from "../../assets/images/invite.svg";
import bell from "../../assets/images/bell.svg";
import "./header.css";
import {useVarAuth} from "../../graphql/graphql/auth/defaults";

const Header = () => {
  const {open, setOpen, isSmall} = useContext(MenuContext);
  const {user = {}} = useVarAuth();

  const handleOpen = () => {
    setOpen(!open);
  };

  return (
    <Box className="headerMain">
      <Box sx={{display: {md: "block", xs: "none"}}}>
        <HeaderTop />
      </Box>
      <Box
        className="headerNav"
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        flexDirection={isSmall ? "row-reverse" : "row"}
      >
        <Box className="topLeftPanel" display="flex" alignItems="center">
          <Box onClick={handleOpen} sx={{display: {xs: "none", md: "block"}}} className="menuIcon">
            <img src={menu} alt="menu" />
          </Box>
          <img src={premium} alt="premium" className="imgPremium" />
        </Box>
        <Box className="topRightPanel" display="flex" alignItems="center">
          <Invite sx={{display: {md: "inline-flex", xs: "none"}}} />
          <img src={bell} alt="bell" className="imgBell" />
          {!isSmall && <img src={user.avatar || profileImg} alt="profile" className="imgProfile" />}
          <Box ml={2} sx={{display: {md: "none", xs: "block"}}} className="menuIcon">
            <MenuIcon onClick={() => setOpen(true)} />
          </Box>
        </Box>
      </Box>
      <Box sx={{display: {md: "none", xs: "block"}}}>
        <HeaderTop />
      </Box>
    </Box>
  );
};

export default Header;
